module.exports = __webpack_public_path__ + "img/icon_order_off.1a82f860.svg";